export const INITIAL_DATA_FORM = "WELCOME_INITIAL_DATA_FORM";